import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, Loader2 } from 'lucide-react';
import { useImpactRecords, ImpactRecord } from '@/hooks/useImpactRecords';
import { ImpactCard } from './ImpactCard';
import { ImpactDetailModal } from './ImpactDetailModal';

export function ImpactHighlights() {
  const navigate = useNavigate();
  const { data: records = [], isLoading } = useImpactRecords({ featuredOnly: true, limit: 6 });
  const [selected, setSelected] = useState<ImpactRecord | null>(null);

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }

  if (records.length === 0) return null;

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {records.map((r) => (
          <ImpactCard key={r.id} record={r} onClick={setSelected} />
        ))}
      </div>
      <div className="text-center mt-8">
        <Button size="lg" variant="outline" onClick={() => navigate('/impacto')}>
          Ver todos los casos de impacto
          <ArrowRight className="h-4 w-4 ml-2" />
        </Button>
      </div>
      <ImpactDetailModal record={selected} onClose={() => setSelected(null)} />
    </>
  );
}
